var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowMaybe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33594C6.68016 1.33594 5.39123 1.72692 4.2949 2.45947C3.19858 3.19201 2.3441 4.23322 1.83951 5.4514C1.33493 6.66957 1.20289 8.01 1.46013 9.30321C1.71736 10.5964 2.35229 11.7843 3.28464 12.7167C4.21699 13.649 5.40489 14.2839 6.69809 14.5412C7.9913 14.7984 9.33173 14.6664 10.5499 14.1618C11.7681 13.6572 12.8093 12.8027 13.5418 11.7064C14.2744 10.6101 14.6654 9.32115 14.6654 8.0026C14.6654 6.23449 13.963 4.53879 12.7128 3.28855C11.4625 2.03831 9.76681 1.33594 7.9987 1.33594ZM9.97401 8.74334H6.02339C5.82693 8.74334 5.63852 8.66531 5.4996 8.52639C5.36069 8.38748 5.28265 8.19906 5.28265 8.0026C5.28265 7.80615 5.36069 7.61773 5.4996 7.47882C5.63852 7.3399 5.82693 7.26186 6.02339 7.26186H9.97401C10.1705 7.26186 10.3589 7.3399 10.4978 7.47882C10.6367 7.61773 10.7147 7.80615 10.7147 8.0026C10.7147 8.19906 10.6367 8.38748 10.4978 8.52639C10.3589 8.66531 10.1705 8.74334 9.97401 8.74334Z",
    fill: "#C57B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMaybe);
export default __webpack_public_path__ + "static/media/yellow-maybe.5bed8e7d7aca696697ec13d7d8c3a7d5.svg";
export { ForwardRef as ReactComponent };